<template>
  <Dropdown :transfer="true" trigger="click" @on-click="actionTrigger">
    <CreateImage ref="CreateImage" v-on:callback="$router.push({ name: 'image' })"></CreateImage>
    <ServerResize ref="ServerResize" v-on:callback="$emit('callback')"></ServerResize>
    <SetSecurityGroup ref="SetSecurityGroup" v-on:callback="$emit('callback')"></SetSecurityGroup>
    <EditServer ref="EditServer" v-on:callback="$emit('callback')"></EditServer>
    <AttachVolume ref="AttachVolume" v-on:callback="$emit('callback')"></AttachVolume>
    <DetachVolume ref="DetachVolume" v-on:callback="$emit('callback')"></DetachVolume>
    <ServerBindFloatingIp ref="ServerBindFloatingIp" v-on:bindComplete="$emit('callback')"></ServerBindFloatingIp>
    <changePassword ref="changePassword"></changePassword>
    <Button :size="size" type="dashed">
      更多操作
      <Icon type="ios-arrow-down"></Icon>
    </Button>
    <DropdownMenu slot="list">
      <DropdownItem name="startServer" v-if="status === 'SHUTOFF'">启动实例</DropdownItem>
      <DropdownItem name="os-getVNCConsole" v-if="status === 'ACTIVE'">连接控制台</DropdownItem>
      <DropdownItem name="createImage" v-if="status === 'ACTIVE' || status === 'SHUTOFF' || status === 'PAUSED' || status === 'SUSPENDED'">创建快照</DropdownItem>
      <DropdownItem name="bindFloatingIp">绑定浮动IP</DropdownItem>
      <!--<DropdownItem>连接接口</DropdownItem>-->
      <!--<DropdownItem>分离接口</DropdownItem>-->
      <DropdownItem name="editServer">编辑实例</DropdownItem>
      <DropdownItem name="attachVolume" v-if="status === 'ACTIVE'">挂载云硬盘</DropdownItem>
      <DropdownItem name="detachVolume" v-if="status === 'ACTIVE'">分离云硬盘</DropdownItem>
      <!--<DropdownItem>更新元数据</DropdownItem>-->
      <DropdownItem name="setSecurityGroup" v-if="status === 'ACTIVE'">编辑安全组</DropdownItem>
      <!--<DropdownItem>控制台</DropdownItem>-->
      <!--<DropdownItem>查看日志</DropdownItem>-->
      <DropdownItem name="pauseServer" v-if="status === 'ACTIVE'">暂停实例</DropdownItem>
      <DropdownItem name="unPauseServer" v-if="status === 'PAUSED'">恢复实例</DropdownItem>
      <DropdownItem name="suspendServer" v-if="status === 'ACTIVE'">挂起实例</DropdownItem>
      <DropdownItem name="resumeServer" v-if="status === 'SUSPENDED'">取消挂起实例</DropdownItem>
      <DropdownItem name="changePassword" v-if="status === 'ACTIVE'"><span :style="{color: '#ff9900'}">重置密码</span></DropdownItem>
      <DropdownItem name="shelveServer" v-if="status === 'ACTIVE' || status === 'SHUTOFF' || status === 'PAUSED' || status === 'SUSPENDED'"><span :style="{color: 'red'}">废弃实例</span></DropdownItem>
      <DropdownItem name="unShelveServer" v-if="status === 'SHELVED' || status === 'SHELVED_OFFLOADED'">取消废弃实例</DropdownItem>
      <DropdownItem name="resize" v-if="status === 'ACTIVE' || status === 'SHUTOFF'"><span :style="{color: 'red'}">调整实例大小</span></DropdownItem>
      <DropdownItem name="confirmResize" v-if="status === 'VERIFY_RESIZE'"><span :style="{color: 'red'}">确认调整实例大小</span></DropdownItem>
      <DropdownItem name="confirmResize" v-if="status === 'VERIFY_RESIZE'">取消调整实例大小</DropdownItem>
      <!--<DropdownItem>锁定实例</DropdownItem>-->
      <!--<DropdownItem>解锁实例</DropdownItem>-->
      <!--<DropdownItem>救援实例</DropdownItem>-->
      <!--<DropdownItem v-if="status === 'RESCUE'>取消救援</DropdownItem>-->
      <DropdownItem name="softRebootServer" v-if="status === 'ACTIVE'"><span :style="{color: 'red'}">软重启实例</span></DropdownItem>
      <DropdownItem name="hardRebootServer" v-if="status === 'ACTIVE' || status === 'ERROR' || status === 'HARD_REBOOT' || status === 'PAUSED' || status === 'REBOOT' || status === 'SHUTOFF'|| status === 'SUSPENDED'"><span :style="{color: 'red'}">硬重启实例</span></DropdownItem>
      <!--<DropdownItem v-if="status === 'ACTIVE'"><span :style="{color: 'red'}">迁移实例</span></DropdownItem>-->
      <!--<DropdownItem v-if="status === 'ACTIVE'">热迁移实例</DropdownItem>-->
      <DropdownItem name="stopServer" v-if="status === 'ACTIVE' || status === 'ERROR'"><span :style="{color: 'red'}">关闭实例</span></DropdownItem>
      <!--<DropdownItem v-if="status === 'ACTIVE' || status === 'ERROR' || status === 'SHUTOFF'"><span :style="{color: 'red'}">重建实例</span></DropdownItem>-->
      <DropdownItem name="deleteServer"><span :style="{color: 'red'}">删除实例</span></DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import { actionPrivateCloudServer, deletePrivateCloudServer } from '@/api/private-cloud/server'
import CreateImage from './action/server-create-image'
import ServerResize from './action/server-resize'
import SetSecurityGroup from './action/server-set-security-group'
import EditServer from './action/server-edit'
import AttachVolume from './action/server-attach-volume'
import DetachVolume from './action/server-detach-volume'
import ServerBindFloatingIp from '../../net/components/server-bind-floating-ip'
import changePassword from './action/server-change-password'

export default {
  name: 'ActionMenu',
  components: {
    CreateImage,
    ServerResize,
    SetSecurityGroup,
    EditServer,
    AttachVolume,
    DetachVolume,
    ServerBindFloatingIp,
    changePassword
  },
  props: {
    status: String,
    server_id: String,
    server_name: String,
    size: {
      type: String,
      default: 'small'
    }
  },
  data () {
    return {

    }
  },
  methods: {
    actionTrigger (name) {
      let reqData = {}
      switch (name) {
        case 'startServer':
          reqData['os-start'] = null
          this.submitActionReq(reqData)
          break
        case 'createImage':
          this.$refs.CreateImage.openModal(this.server_id, this.server_name)
          break
        case 'bindFloatingIp':
          this.$refs.ServerBindFloatingIp.openModal(this.server_id, 'server')
          break
        case 'resize':
          this.$refs.ServerResize.openModal(this.server_id)
          break
        case 'setSecurityGroup':
          this.$refs.SetSecurityGroup.openModal(this.server_id)
          break
        case 'editServer':
          this.$refs.EditServer.openModal(this.server_id)
          break
        case 'attachVolume':
          this.$refs.AttachVolume.openModal(this.server_id)
          break
        case 'detachVolume':
          this.$refs.DetachVolume.openModal(this.server_id)
          break
        case 'changePassword':
          this.$refs.changePassword.openModal(this.server_id, this.server_name)
          break
        case 'confirmResize':
          reqData['confirmResize'] = null
          this.submitActionReq(reqData)
          break
        case 'revertResize':
          reqData['revertResize'] = null
          this.submitActionReq(reqData)
          break
        case 'stopServer':
          reqData['os-stop'] = null
          this.submitActionReq(reqData)
          break
        case 'softRebootServer':
          reqData['reboot'] = {
            type: 'SOFT'
          }
          this.submitActionReq(reqData)
          break
        case 'hardRebootServer':
          reqData['reboot'] = {
            type: 'HARD'
          }
          this.submitActionReq(reqData)
          break
        case 'resumeServer':
          reqData['resume'] = null
          this.submitActionReq(reqData)
          break
        case 'suspendServer':
          reqData['suspend'] = null
          this.submitActionReq(reqData)
          break
        case 'pauseServer':
          reqData['pause'] = null
          this.submitActionReq(reqData)
          break
        case 'unPauseServer':
          reqData['unpause'] = null
          this.submitActionReq(reqData)
          break
        case 'shelveServer':
          reqData['shelve'] = null
          this.submitActionReq(reqData)
          break
        case 'unShelveServer':
          reqData['unshelve'] = null
          this.submitActionReq(reqData)
          break
        case 'deleteServer':
          this.deleteServerAction()
          break
        case 'os-getVNCConsole':
          this.getVNCConsole()
          break
      }
    },
    submitActionReq (reqData, modal) {
      actionPrivateCloudServer(reqData, this.server_id).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
        this.$emit('callback')
        this[modal] = false
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    deleteServerAction () {
      this.$Modal.confirm({
        title: '删除',
        content: '确定要删除实例「' + this.server_name + '」吗？',
        onOk: () => {
          deletePrivateCloudServer(this.server_id).then(res => {
            this.$Notice.success({title: '操作成功！'})
            this.$emit('callback')
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    getVNCConsole () {
      let reqData = {
        'os-getVNCConsole': {
          // protocol: 'vnc',
          type: 'novnc'
        }
      }
      actionPrivateCloudServer(reqData, this.server_id).then(res => {
        window.open(res.data.console.url, '_blank')
      }).catch(res => {
        this.$Notice.error({
          title: '控制台当前不可用'
        })
        console.error(res.response)
      })
    }
  }
}
</script>

<style scoped>

</style>
